import { GridAction } from '@eforall/dashboard';
import { AcceleratorEnrollment } from '@interfaces';

export function getActions() {

	const actions: GridAction<AcceleratorEnrollment>[] = [];

	return actions;
}